function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 .5l2.02 6.219h6.54l-5.29 3.843 2.02 6.22L9 12.937 3.71 16.78l2.02-6.219L.44 6.72h6.54z",
  fill: "currentColor"
});

var SvgStar = function SvgStar(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    height: 17,
    width: 18
  }, props), _ref);
};

export default SvgStar;